
<GenAILayout>
  <div class="landingpage-goal-container">
    <div class="landingpage-goal-inner-container">
      <div class="landingpage-goal-wrapper">
        <h1 class="landingpage-goal-header">
          {{ $t('gen_ai.landingpage_goal.header.text') }}
        </h1>

        <div
          v-for="(intent, index) in intents"
          :key="index"
          class="landingpage-goal-card-wrapper"
        >
          <cvt-goal-card
            :header-text="intent.text"
            :icon="intent.icon"
            :is-active="selectedIntent === intent.intent"
            :value="intent.intent"
            @click="(value) => onClickGoalCard(value)"
          >
          </cvt-goal-card>
        </div>
      </div>
    </div>
    <hr />
    <div class="landingpage-goal-wrap">
      <div class="landingpage-goal-inner-btn-wrap">
        <cvt-button
          class="landingpage-goal-btn skip"
          :text="$t('editor.footer.back')"
          shape="round"
          color="light"
          :prepend="false"
          @click="handleBack"
        ></cvt-button>

        <cvt-button
          class="landingpage-goal-btn continue"
          :text="$t('custom_domain.ui.unlink_dialog.buttons.continue')"
          shape="round"
          color="primary"
          icon="arrow-right"
          :disabled="disabled"
          :prepend="false"
          @click="handleOnClick"
        ></cvt-button>
      </div>
    </div>
  </div>
</GenAILayout>
